let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ah5aA")).then(() => parcelRequire('40saR'));